export default "__VITE_ASSET__34608496__"